import React from 'react';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import styles from '../modalPayment.module.scss';
import { formatRut } from '../../../../../../helpers/app';
import { images } from '../../../../../../constants/images';
import { InitialContentProps } from '../../../../../../interfaces/components';

export const InitialContent: React.FC<InitialContentProps> = ({
    handleCloseClick,
    handlePaymentClick,
    url,
    user,
    carInfo,
    formData
}) => {
    const getDisplayValue = (carInfoExists: boolean, userValue?: string, formDataValue?: string) => {
        return carInfoExists ? (userValue || '-') : (formDataValue || '-');
    };

    const getRutDisplay = () => {
        const hasCarInfo = !!carInfo;
        const rutValue = getDisplayValue(hasCarInfo, user?.legal_id, formData?.rut);
        return rutValue !== '-' ? formatRut(rutValue) : '-';
    };

    const hasCarInfo = !!carInfo;

    return (
        <div className={styles.content}>
            <div className={styles.closeButton}>
                <IconButton onClick={handleCloseClick}>
                    <CloseIcon />
                </IconButton>
            </div>
            <div className={styles.header}>
                <h1>Verificación y selección de un medio de pago</h1>
                <p>Esta información es crucial para garantizar el envío correcto de tu informe. Si encuentras algún error, haz clic en "Cancelar" para corregir la información.</p>
            </div>
            <div className={styles.summary}>
                <h2>Resumen información</h2>
                <div className={styles.summaryGrid}>
                    {!hasCarInfo && (
                        <div className={styles.summaryRow}>
                            <span>Patente:</span>
                            <span>{getDisplayValue(hasCarInfo, carInfo?.plate, formData?.plate)}</span>
                        </div>
                    )}
                    <div className={styles.summaryRow}>
                        <span>Rut:</span>
                        <span>{getRutDisplay()}</span>
                    </div>
                    <div className={styles.summaryRow}>
                        <span>Correo electrónico:</span>
                        <span>{getDisplayValue(hasCarInfo, user?.email, formData?.email)}</span>
                    </div>
                </div>
            </div>
            <div className={styles.priceSection}>
                <h2>Valor informe</h2>
                <div className={styles.priceRow}>
                    <span>Informe vehicular</span>
                    <span>$ 7990</span>
                </div>
                <div className={styles.totalRow}>
                    <span>Valor total:</span>
                    <span>$ 7990</span>
                </div>
            </div>
            <div className={styles.paymentSection}>
                <h2>Selecciona una forma de pago</h2>
                <div className={styles.paymentOption}>
                    <input type="radio" id="pagaEnLinea" name="payment" value="Paga en linea" checked readOnly/>
                    <label htmlFor="pagaEnLinea">
                        <img src={images.pagaEnLinea} alt="PagaEnLinea" className={styles.pagalineaImage} />
                    </label>
                </div>
            </div>
            <div className={styles.footer}>
                <p>Al "Ir a pagar" estarás aceptando los <a href="https://d2au7udyarrxuw.cloudfront.net/icarcheck/tyc_icar.pdf" target="_blank" rel="noopener noreferrer">Términos y Condiciones</a> y el envío de promociones.</p>
                <div className={styles.buttons}>
                    <button className={styles.backButton} onClick={handleCloseClick}>
                        Cancelar
                    </button>
                    <button
                        className={`${styles.payButton} ${!url ? styles.disabled : ''}`}
                        onClick={handlePaymentClick}
                        disabled={!url}
                    >
                        Ir a pagar
                    </button>
                </div>
            </div>
        </div>
    );
};
